// src/components/ui/Skeleton/styles.ts
import styled, { keyframes } from "styled-components";

const shimmer = keyframes`
  0% { background-position: -468px 0; }
  100% { background-position: 468px 0; }
`;

export const SkeletonBlock = styled.div<{
  $width?: string;
  $height?: string;
  $radius?: number;
  $circle?: boolean;
}>`
  width: ${(p) => p.$width ?? "100%"};
  height: ${(p) => p.$height ?? "14px"};
  flex-shrink: 0;
  border-radius: ${(p) =>
    p.$circle ? "50%" : `${p.$radius ?? p.theme.tokens.radii.sm}px`};
  background: ${(p) => {
    const c = p.theme.tokens.colors;
    return `linear-gradient(90deg, ${c.line} 25%, ${c.softBg} 37%, ${c.line} 63%)`;
  }};
  background-size: 936px 100%;
  animation: ${shimmer} 1.4s ease-in-out infinite;
`;
